/**
 * Host → service id. Must stay identical to the historical middleware rule:
 * the first hostname label, or the second label when the first is `www`.
 * The port, if present, stays attached to that label (`localhost:3000`).
 *
 * @param {string | null | undefined} host
 * @returns {string | undefined}
 */
function serviceIdFromHost(host) {
  if (!host) return undefined
  const parts = host.split('.')
  if (parts[0] === 'www') return parts[1]
  return parts[0]
}

/**
 * Next.js `has: [{ type: 'host' }]` matches the hostname with the port
 * removed and lowercased, anchored with ^$. `www.` rules must come first
 * so `www.pairl.jp` does not capture site `www`.
 */
const HOST_PATTERNS = [
  'www\\.(?<site>[^.]+)\\..*',
  'www\\.(?<site>[^.]+)',
  '(?<site>[^.]+)\\..*',
  '(?<site>[^.]+)',
]

const PUBLIC_FILES = [
  { source: '/robots.txt', destination: '/:site/robots/api' },
  { source: '/sitemap.xml', destination: '/:site/sitemap/api' },
  { source: '/sitemap.xml.gz', destination: '/:site/sitemap/api' },
  { source: '/image-sitemap.xml', destination: '/:site/sitemap/image' },
]

function publicFileRewrites() {
  /** @type {{ source: string, has: { type: 'host', value: string }[], destination: string }[]} */
  const rewrites = []
  for (const file of PUBLIC_FILES) {
    for (const value of HOST_PATTERNS) {
      rewrites.push({
        source: file.source,
        has: [{ type: 'host', value }],
        destination: file.destination,
      })
    }
  }
  return rewrites
}

/**
 * Site segment a beforeFiles rewrite would capture for this Host header.
 * Mirrors `matchHas` in next/dist/shared/lib/router/utils/prepare-destination.js.
 *
 * @param {string | null | undefined} host
 * @returns {string | undefined}
 */
function rewriteSiteFromHost(host) {
  if (!host) return undefined
  const hostname = host.split(':', 1)[0].toLowerCase()
  for (const pattern of HOST_PATTERNS) {
    const match = hostname.match(new RegExp(`^${pattern}$`))
    if (match && match.groups && match.groups.site) return match.groups.site
  }
  return undefined
}

module.exports = {
  HOST_PATTERNS,
  PUBLIC_FILES,
  serviceIdFromHost,
  publicFileRewrites,
  rewriteSiteFromHost,
}
